// extracted by mini-css-extract-plugin
export default {"root":"progress-bar_root__bft5W","bar":"progress-bar_bar__BhUs1"};